export const normalizeInternationalPhoneValue = (value: string) => {
  const digits = value.replace(/\D/g, '');

  if (!digits) return value === '+' ? value : '';
  if (digits.startsWith('89')) return `+7${digits.slice(1)}`;
  if (!value.startsWith('+')) return `+${digits}`;

  return value;
};
